__turbopack_context__.v({
  "calculator_cta": "styles-module-scss-module__ruwMRq__calculator_cta",
  "cta_wrapper": "styles-module-scss-module__ruwMRq__cta_wrapper",
  "results_header": "styles-module-scss-module__ruwMRq__results_header",
  "select_wrapper": "styles-module-scss-module__ruwMRq__select_wrapper",
});
